const getBearToken = () => {
    const BToken = localStorage.getItem("veeperAuthToken");
    return JSON.parse(BToken);
}

export default getBearToken;